function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 114,
  height: 47,
  rx: 8,
  fill: "#262439"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4943 8L9 23.7864L18.4943 19.4675V8Z",
  fill: "#8891B1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4943 19.4675L9 23.7865L18.4943 29.4114V19.4675Z",
  fill: "#63688E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9999 23.7864L18.4941 8V19.4675L27.9999 23.7864Z",
  fill: "#63688E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4941 29.4114L27.9999 23.7865L18.4941 19.4675V29.4114Z",
  fill: "#464A75"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9 25.5964L18.4943 39V31.2099L9 25.5964Z",
  fill: "#8891B1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4941 31.2099V39L27.9999 25.5964L18.4941 31.2099Z",
  fill: "#63688E"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 8.5,
  r: 0.5,
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.5,
  cy: 8.5,
  r: 0.5,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 8.5,
  r: 0.5,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 8.5,
  r: 0.5,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.5,
  cy: 8.5,
  r: 0.5,
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 12.5,
  r: 0.5,
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.5,
  cy: 12.5,
  r: 0.5,
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 12.5,
  r: 0.5,
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 12.5,
  r: 0.5,
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.5,
  cy: 12.5,
  r: 0.5,
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 16.5,
  r: 0.5,
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.5,
  cy: 16.5,
  r: 0.5,
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 16.5,
  r: 0.5,
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 16.5,
  r: 0.5,
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.5,
  cy: 16.5,
  r: 0.5,
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 20.5,
  r: 0.5,
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.5,
  cy: 20.5,
  r: 0.5,
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 20.5,
  r: 0.5,
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 20.5,
  r: 0.5,
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.5,
  cy: 20.5,
  r: 0.5,
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M39.944 20C42.584 20 45.16 18.304 45.16 14.4C45.16 10.496 42.584 8.8 39.944 8.8H36.44V20H39.944ZM38.52 10.72H39.288C40.264 10.72 41.064 10.928 41.816 11.44C42.584 11.952 43.048 12.976 43.048 14.4C43.048 15.824 42.584 16.848 41.816 17.36C41.064 17.872 40.264 18.08 39.288 18.08H38.52V10.72ZM54.9356 15.792C54.9356 14.88 54.6476 13.936 54.0716 13.152C53.4956 12.336 52.4556 11.808 51.1756 11.808C48.4076 11.808 47.3036 14.048 47.3036 15.968C47.3036 17.888 48.4076 20.128 51.1756 20.128C52.9356 20.128 54.1516 19.344 54.8396 17.776L53.2396 17.184C52.7596 18.016 52.1036 18.432 51.2876 18.432C50.1356 18.432 49.4316 17.584 49.3836 16.608H54.9356V15.792ZM51.1756 13.504C52.1036 13.504 52.6796 14.016 52.9036 15.04H49.4316C49.5756 14.192 50.2316 13.504 51.1756 13.504ZM57.5463 20H59.6263V15.2H63.6583V13.28H59.6263V10.72H64.6343V8.8H57.5463V20ZM66.8586 10.528C67.3546 11.024 68.1866 11.024 68.6826 10.528C69.1786 10.032 69.1786 9.2 68.6826 8.704C68.1866 8.208 67.3546 8.208 66.8586 8.704C66.3626 9.2 66.3626 10.032 66.8586 10.528ZM66.7786 20H68.7626V11.936H66.7786V20Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M42.744 34.192L38.632 26.8H36.44V38H38.52V30.608L42.632 38H44.824V26.8H42.744V34.192ZM55.1856 33.792C55.1856 32.88 54.8976 31.936 54.3216 31.152C53.7456 30.336 52.7056 29.808 51.4256 29.808C48.6576 29.808 47.5536 32.048 47.5536 33.968C47.5536 35.888 48.6576 38.128 51.4256 38.128C53.1856 38.128 54.4016 37.344 55.0896 35.776L53.4896 35.184C53.0096 36.016 52.3536 36.432 51.5376 36.432C50.3856 36.432 49.6816 35.584 49.6336 34.608H55.1856V33.792ZM51.4256 31.504C52.3536 31.504 52.9296 32.016 53.1536 33.04H49.6816C49.8256 32.192 50.4816 31.504 51.4256 31.504ZM61.919 36.24C61.679 36.368 61.423 36.432 61.151 36.432C60.447 36.432 60.095 36.08 60.095 35.12V31.632H62.223V29.936H60.095V26.672L58.111 27.92V29.936H56.863V31.632H58.111V35.152C58.111 37.12 59.215 38.128 61.071 38.128C61.535 38.128 61.967 38.032 62.383 37.84L61.919 36.24ZM71.8566 35.472L70.4966 29.936H68.6406L67.2806 35.472L65.8406 29.936H63.8406L66.4166 38H68.1766L69.5686 32.784L70.9606 38H72.7206L75.2966 29.936H73.2966L71.8566 35.472ZM77.942 36.96C78.678 37.744 79.67 38.128 80.934 38.128C82.198 38.128 83.19 37.744 83.926 36.96C84.662 36.176 85.03 35.168 85.03 33.968C85.03 32.768 84.662 31.776 83.926 30.992C83.19 30.208 82.198 29.808 80.934 29.808C79.67 29.808 78.678 30.208 77.942 30.992C77.206 31.776 76.838 32.768 76.838 33.968C76.838 35.168 77.206 36.176 77.942 36.96ZM79.462 32.224C79.83 31.744 80.31 31.504 80.934 31.504C81.558 31.504 82.038 31.744 82.406 32.224C82.774 32.688 82.95 33.28 82.95 33.968C82.95 34.656 82.774 35.248 82.406 35.728C82.038 36.192 81.558 36.432 80.934 36.432C80.31 36.432 79.83 36.192 79.462 35.728C79.094 35.248 78.918 34.656 78.918 33.968C78.918 33.28 79.094 32.688 79.462 32.224ZM89.3578 35.136C89.3578 32.688 90.2538 31.584 91.5178 31.584C91.8218 31.584 92.1098 31.664 92.3498 31.808L92.7178 29.968C92.3658 29.856 92.0458 29.808 91.7418 29.808C90.7977 29.808 89.9338 30.336 89.3578 31.248V29.936H87.3738V38H89.3578V35.136ZM94.8019 38H96.7859V34.192L99.6339 38H102.066L98.6259 33.648L101.858 29.936H99.4099L96.7859 33.104V26.672H94.8019V38Z",
  fill: "white"
});

var SvgDefiNetworkLogo = function SvgDefiNetworkLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 47,
    viewBox: "0 0 114 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefiNetworkLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/defi-network-logo.98186edb.svg";
export { ForwardRef as ReactComponent };